export default __webpack_public_path__ + "static/ux.banana-f55b36e381406f7bd2d180447032e71a.png";